import { Stack, Skeleton } from '@mui/material';

export const AmenitiesSkeleton = () => (
  <Stack data-testid="amenities-skeleton" padding={5}>
    {[...Array(6)].map((_, index) => (
      <Skeleton key={index} height={40} />
    ))}
  </Stack>
);
